import axiosInstance from ".";

export const getPlans = async ({ queryKey }) => {
  const [queries = {}] = queryKey;
  return axiosInstance.get("/plans", { params: queries });
};


export const addPlan = (data) => {
  return axiosInstance.post("/plans", data);
};

export const updatePlan = (data) => {
  const { id, ...payload } = data;
  return axiosInstance.put(`/plans/${id}`, payload);
};

export const deletePlan = (id) => {
  return axiosInstance.delete(`/plans/${id}`);
};
